export default "__VITE_ASSET__Bu9DxxZv__"